import React from 'react';
import Anchor from '@sdtech/sd-ui/Anchor';

function ErrorFragment() {
  return (
    <div>
      You have requested access to an article on ScienceDirect via a ScienceDirect Gateway
      link from another service.
      However, the Service you&apos;re using is not authorized to access this Product.
      Please contact the ScienceDirect
      {' '}
      <Anchor href="https://service.elsevier.com/app/contact/supporthub/sciencedirect/" className="u-clr-orange">support team </Anchor>
      for further information or contact your Librarian for details.
    </div>
  );
}

export default ErrorFragment;
